export default "__VITE_ASSET__aF2GQjNb__"